import i18n from 'i18next'

import { type ErrorDetails } from './export-queries'

type ErrorResult = {
  title: string
  message: string
  code: string
}

// api/src/chalicelib/exceptions.py
export const getErrorMessage = (errorDetails?: ErrorDetails): ErrorResult => {
  const result: ErrorResult = {
    title: i18n.t('errors.something_went_wrong', { ns: 'export' }),
    message: i18n.t('errors.default', { ns: 'export' }),
    code: 'unknown',
  }

  if (!errorDetails?.code) return result

  result.code = errorDetails.code

  if (
    ['InvalidIntegrationCredentialsException', 'ProBuilderInvalidConfigException'].includes(
      errorDetails.code,
    )
  ) {
    result.message = errorDetails.message!
  }

  if (errorDetails.code === 'ProBuilderCreateItemException') {
    result.message = i18n.t('errors.create', { ns: 'export' })
  }

  if (errorDetails.code === 'ProBuilderMappingException') {
    let prefix = ''

    if (errorDetails.skipped) {
      prefix = i18n.t('errors.skipped_prefix', { ns: 'export' })
    }

    console.error(errorDetails)
    result.message = `${prefix}${i18n.t('errors.mapping', { ns: 'export' })}`
  }

  return result
}
